module.exports = "<div class=\"timeline\">\n    <div class=\"timelineElement\" *ngFor=\"let mesure of mesures\">\n        <jhi-timeline-element *ngIf=\"getCouleurMap().size > 0\"  [mesure]=\"mesure\" [couleurMap]=\"getCouleurMap()\" [juridiction]=\"juridiction\"></jhi-timeline-element>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/requete/historique-requete/timeline/timeline.component.html
// module id = 827
// module chunks = 0